var appMarketplace = angular.module('appMarketplace');
appMarketplace.factory('responseErrorInterceptor', ['$q', function ($q) {
    return {
        responseError: function (rejection) {
            console.log(rejection);
            var requestedUrl = rejection.config.url;

            if (requestedUrl.split('/')[2] === 'rest') { //spring webmvc path
                var rejectionData = rejection.data;
                var responseCode = rejection.status;
                if (responseCode === 404 && !rejectionData.message) {
                    console.warn("Url '" + requestedUrl + "' not found");
                    rejection.data = {};
                    rejection.data.message = 'Requested url not found';
                } else if (!rejectionData || rejectionData.message === undefined || rejectionData.validationErrors === undefined) {
                    console.warn('Unexpected response has been received with status ' + responseCode
                        + '. Requested url is ' + requestedUrl);
                    rejection.data = {};
                    rejection.data.message = 'Unexpected error';
                }
            }
            return $q.reject(rejection);
        }
    }
}]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/interceptors/response-error-interceptor.js
// module id = 260
// module chunks = 37